import { FertilizerCellDisplay } from '../CellDisplays'
import { TraitCellDisplayProps } from '../types'

export const FertilizerCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const detail = params.row.findDetail({ traitId, year })
  return <FertilizerCellDisplay value={detail?.value} />
}
